import React from 'react';
import styled from '@emotion/styled';
import { ArrowLink } from '../../../../../ui';
import { useTranslation } from '../../../../shared/i18n/translate/useTranslation';
import { useUrlForPageId } from '../../../../app/pages/ui/utils/useUrlForPageId';
import { PassengersPageId } from '../../../../app/pages/domain/constants/PageId';

export const StyledOrderingFoodLink = styled(ArrowLink)``;

export const OrderingFoodLink = () => {
	const { t } = useTranslation();
	const orderingFoodUrl = useUrlForPageId(
		PassengersPageId.ShopDineAndRelax,
		'filters=mobile-ordering',
	);

	return (
		<StyledOrderingFoodLink href={orderingFoodUrl}>
			{t('flight_details_ordering_food_link')}
		</StyledOrderingFoodLink>
	);
};
